<section id="secao-incube-sua-empresa">
  <div class="container">
    <div class="titulo-incube">
      <h3>Programa de Incubação de Empresas Educere</h3>
    </div>

    <div class="descricao-incube">
      <p>
        A Fundação Educere oferece suporte para o desenvolvimento do negócio
        em todas as etapas da incubação, desde a qualificação do potencial
        empreendedor à aceleração da empresa graduada.
      </p>
    </div>

    <div class="area-linktree">
      <a href="https://tr.ee/lB1AUmpPkG" target="_blank" class="btn-linktree">
        Acesse nosso Linktree
      </a>
    </div>
  </div>
</section>
